import { render, staticRenderFns } from "./SfBottomNavigationItem.vue?vue&type=template&id=9fee62d2&"
import script from "./SfBottomNavigationItem.vue?vue&type=script&lang=js&"
export * from "./SfBottomNavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports